module.exports = __webpack_public_path__ + "img/lo-studio-image-3.308bd7f7.png";